import {useCallback, useEffect, useMemo, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {useFormikContext} from "formik";
import {euroFormat} from "../../../../utils/usefullFunctions";
import {Table} from "react-bootstrap";
import CalculateTool from "./CalculateTool";
import CustomDataGrid from "../../../table/CustomDataGrid";
import EditFinanceModal from "../../EditFinanceModal";


const TotalTable = () => {
    const {values, setFieldValue} = useFormikContext();


    const {
        service_form_project_hours_cost,
        service_form_project_articles_cost,
        service_form_project_hour_tariffs,
        service_form_project_products_cost,
        service_form_project_hardware_cost,
        service_form_project_data_total,
        service_form_project_risc,
        service_form_project_options
    } = values

    const columns = useMemo(() => {
        return [
            {
                name: 'name', header: 'Onderdeel', minWidth: 300, editable: false,
                render: ({value, data}) => {
                    if (data.id === 5 && !service_form_project_options[8].value) return ""
                    if (data.id === 6 && !service_form_project_options[5].value) return ""
                    if (data.id === 7 && !service_form_project_options[7].value) return ""
                    if (data.id === 8 && !service_form_project_options[3].value) return ""
                    if (data.id === 9 && !service_form_project_options[4].value) return ""
                    return value
                }
            },
            {
                name: 'cost', header: 'Kost', defaultFlex: 1, minWidth: 50, type: 'number', editable: false,
                render: ({value}) => {
                    if (value) return euroFormat(value)
                },
                onRender: (cellProps) => {
                    cellProps.style.background = '#f8f8f8'
                }
            },
            {
                name: 'sale', header: 'Verkoop', defaultFlex: 1, minWidth: 50, type: 'number', editable: false,
                render: ({value}) => {
                    if (value) return euroFormat(value)
                },
                onRender: (cellProps) => {
                    cellProps.style.background = '#f8f8f8'
                }
            },
            {
                name: 'margin', header: 'Marge', defaultFlex: 1, minWidth: 50, type: 'number',
                onRender: (cellProps, {data}) => {
                    if (data.id >= 6) cellProps.style.background = '#f8f8f8'
                },
                render: ({value, data}) => {
                    if (data.id === 5 && !service_form_project_options[8].value) return ""
                    if (data.id === 6 && !service_form_project_options[5].value) return ""
                    if (data.id === 7 && !service_form_project_options[7].value) return ""
                    if (data.id === 8 && !service_form_project_options[3].value) return ""
                    if (data.id === 9 && !service_form_project_options[4].value) return ""
                    if (value) return (value * 100).toFixed() + "%"
                }
            },
            {name: 'comment', header: 'Toelichting', minWidth: 300},

        ];
    }, [service_form_project_options])

    const [totals, setTotals] = useState({
        cost: 0,
        sale: 0,
        margin: 0,
    })


    const [dataSource, setDataSource] = useState(service_form_project_data_total);

    useEffect(() => {
        const t = dataSource.reduce((prev, curr) => {
            prev.cost = prev.cost + parseFloat(curr.cost || 0)
            prev.sale = prev.sale + parseFloat(curr.sale || 0)
            return prev
        }, {
            cost: 0,
            sale: 0,
        })
        // risico toevoegen
        t.risc = t.cost * (parseInt(service_form_project_risc) / 100)

        setTotals({
            cost: t.cost,
            sale: t.sale,
            margin: parseFloat((t.sale - (t.cost + t.risc)) / t.sale) * 100,
            risc: t.risc
        })
        setFieldValue("service_form_project_data_total", dataSource)
        setFieldValue("service_form_project_total_sums", {
            cost: t.cost,
            sale: t.sale,
            margin: parseFloat((t.sale - (t.cost + t.risc)) / t.sale) * 100,
            risc: t.risc
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource])

    useEffect(() => {
        let data = [...dataSource]

        data[0].cost = service_form_project_hours_cost.ohddc;
        data[0].sale = service_form_project_hours_cost.ohddc / (1 - service_form_project_hour_tariffs.oh.margin);
        data[0].margin = service_form_project_hour_tariffs.oh.margin;

        data[1].cost = service_form_project_hours_cost.ohveld;
        data[1].sale = service_form_project_hours_cost.ohveld / (1 - service_form_project_hour_tariffs.oh.margin);
        data[1].margin = service_form_project_hour_tariffs.oh.margin;

        data[2].cost = service_form_project_hours_cost.pl;
        data[2].sale = service_form_project_hours_cost.pl / (1 - service_form_project_hour_tariffs.pl.margin);
        data[2].margin = service_form_project_hour_tariffs.pl.margin;

        data[3].cost = service_form_project_hours_cost.boaBasis;
        data[3].sale = service_form_project_hours_cost.boaBasis / (1 - service_form_project_hour_tariffs.boa.margin);
        data[3].margin = service_form_project_hour_tariffs.boa.margin;

        data[4].cost = service_form_project_hours_cost.boa;
        data[4].sale = service_form_project_hours_cost.boa / (1 - service_form_project_hour_tariffs.boa.margin);
        data[4].margin = service_form_project_hour_tariffs.boa.margin;

        data[5].cost = service_form_project_hours_cost.energy;
        data[5].sale = service_form_project_hours_cost.energy / (1 - service_form_project_hour_tariffs.boa.margin);

        if (service_form_project_articles_cost) {
            data[6].cost = service_form_project_articles_cost.cloud.cost;
            data[6].sale = service_form_project_articles_cost.cloud.sale;
            data[6].margin = parseFloat((service_form_project_articles_cost.cloud.sale - service_form_project_articles_cost.cloud.cost) / service_form_project_articles_cost.cloud.sale);

            data[7].cost = service_form_project_articles_cost.vpn.cost;
            data[7].sale = service_form_project_articles_cost.vpn.sale;
            data[7].margin = 0.3;

            data[8].cost = service_form_project_articles_cost.storing.cost;
            data[8].sale = service_form_project_articles_cost.storing.sale;
            data[8].margin = ((service_form_project_articles_cost.storing.sale - service_form_project_articles_cost.storing.cost) / service_form_project_articles_cost.storing.sale);

            data[9].cost = service_form_project_articles_cost.storing24.cost;
            data[9].sale = service_form_project_articles_cost.storing24.sale;
            data[9].margin = ((service_form_project_articles_cost.storing24.sale - service_form_project_articles_cost.storing24.cost) / service_form_project_articles_cost.storing24.sale);

            data[10].cost = service_form_project_products_cost.cost;
            data[10].sale = service_form_project_products_cost.list;
            data[10].margin = parseFloat((service_form_project_products_cost.list - service_form_project_products_cost.cost) / service_form_project_products_cost.list);

            data[11].cost = service_form_project_hardware_cost.cost;
            data[11].sale = service_form_project_hardware_cost.sale;
            data[11].margin = parseFloat((service_form_project_hardware_cost.sale - service_form_project_hardware_cost.cost) / service_form_project_hardware_cost.sale);

        }
        setDataSource(data)
    }, [service_form_project_hours_cost, service_form_project_articles_cost, service_form_project_products_cost, service_form_project_hardware_cost, service_form_project_hour_tariffs, service_form_project_risc])

    const onEditComplete = useCallback(({value, columnId, rowId}) => {
        const data = [...dataSource];
        if (columnId === "comment") data[rowId][columnId] = value
        else if (columnId === "margin") {
            value = parseFloat(value)
            const tariffs = {...service_form_project_hour_tariffs}
            if ([3, 4, 5].includes(rowId)) {
                tariffs.boa.margin = value
                setFieldValue("service_form_project_hour_tariffs", tariffs)
                data[3][columnId] = value
                data[4][columnId] = value
                data[5][columnId] = value
            }
            if ([0, 1].includes(rowId)) {
                tariffs.oh.margin = value
                setFieldValue("service_form_project_hour_tariffs", tariffs)
                data[0][columnId] = value
                data[1][columnId] = value
            }
            if ([2].includes(rowId)) {
                tariffs.pl.margin = value
                setFieldValue("service_form_project_hour_tariffs", tariffs)
                data[2][columnId] = value
            }

        }
        setDataSource(data);
    }, [dataSource])


    return <><CustomDataGrid
        idProperty="id"
        onEditComplete={onEditComplete}
        editable={true}
        columns={columns}
        dataSource={dataSource}

    />


        <Table bordered>
            <tbody>
            <tr>
                <th>Totaal</th>
                <th width={180}>{euroFormat(totals.cost + totals.risc)}</th>
                <th width={180}>{service_form_project_risc}% risico {euroFormat(totals.risc)}</th>
                <th width={180}>{euroFormat(totals.sale)}</th>
                <th>{totals.margin.toFixed(2)}%</th>
            </tr>
            </tbody>
        </Table>

        <CalculateTool totals={totals}/>
        <EditFinanceModal exists={{totalPrice: totals.sale, margin: totals.margin.toFixed(2) }}/>
    </>
}


export default TotalTable